import React from "react";
import styled from "../../lib/styled";
import { Layer } from "grommet";

interface SpoilerImageProps {
  image: string;
}
export const SpoilerImage: React.FC<SpoilerImageProps> = (props) => {
  const [show, setShow] = React.useState<boolean>(false);

  return (
    <SpoilerWrapper onClick={() => setShow(true)}>
      <SpoilerMessage>Click to see spoilers!</SpoilerMessage>
      <BlurredImage image={props.image} />
      {show && (
        <Layer
          onEsc={() => setShow(false)}
          onClickOutside={() => setShow(false)}
        >
          <SpoiledImage src={props.image} />
        </Layer>
      )}
    </SpoilerWrapper>
  );
};

const SpoilerWrapper = styled.div`
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 28.125%;
  padding-top: 28.125%;
  cursor: pointer;
  background-color: ${({ theme }) => theme.color.darkThree};
`;

const SpoilerMessage = styled.div`
  position: absolute;
  z-index: 10;
  font-family: "Keep Calm";
  letter-spacing: 2px;
  text-shadow: 0 0 3px #00000073;
  color: white;
  text-transform: uppercase;
  text-align: center;
`;

const BlurredImage = styled.div<{ image: string }>`
  filter: blur(30px);
  width: 100%;
  height: 100%;
  background-image: ${({ image }) => `url(${image})`};
  background-size: cover;

  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
`;

const SpoiledImage = styled.img`
  margin: 0;
`;
